(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mood-personalized-mirror"] && !Shopify.designMode) return;
  try {
    
  function initializeMoodMirrors() {
    document.querySelectorAll('[data-mood-mirror]').forEach((root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const form = root.querySelector('form');
      if (!form) return;
      const previewText = (key, value) => { root.querySelectorAll('[data-preview="' + key + '"]').forEach((element) => { element.textContent = value; }); };
      const fieldValue = (name) => form.elements.namedItem('properties[' + name + ']')?.value.trim() || '';
      const cleanProfile = (value) => value.replace(/^@/, '');
      const updatePreview = () => {
        const first = cleanProfile(fieldValue('Premier pseudo Instagram')) || 'votre.pseudo';
        const second = cleanProfile(fieldValue('Deuxième pseudo Instagram'));
        previewText('profile1', first);
        previewText('profile2', second);
        previewText('author', first);
        previewText('time', fieldValue('Heure à afficher') || '06:28');
        previewText('location', fieldValue('Ville ou localisation') || 'Votre localisation');
        previewText('liked', fieldValue('Aimé par') || 'vos.proches');
        previewText('caption', fieldValue('Texte de la publication') || 'Votre message, vos emojis ✨ et vos #hashtags');
        [['likes', 'Nombre de likes', '206 K'], ['comments', 'Nombre de commentaires', '486'], ['reposts', 'Nombre de republications', '1 164'], ['shares', 'Nombre de partages', '29,4 K']].forEach(([key, name, fallback]) => {
          const value = fieldValue(name);
          previewText(key, value && Number.isFinite(Number(value)) ? new Intl.NumberFormat('fr-FR', { notation: Number(value) >= 10000 ? 'compact' : 'standard', maximumFractionDigits: 1 }).format(Number(value)) : fallback);
        });
        root.querySelector('[data-preview-second]').hidden = !second;
        root.querySelector('[data-preview-fiction]').hidden = !fieldValue('Type de référence Aimé par').startsWith('Personnalité publique');
        root.querySelector('[data-avatar-fallback="1"]').textContent = first[0].toUpperCase();
        previewText('date', fieldValue('Date affichée') || 'Il y a 2 jours');
      };
      const updateSize = () => {
        const radio = form.querySelector('input[name="id"]:checked');
        if (!radio) return;
        previewText('size', radio.dataset.size);
        const dimensions = radio.dataset.size.match(/(\d+)\s*[×x]\s*(\d+)/);
        if (!dimensions) return;
        const height = Number(dimensions[1]);
        const width = Number(dimensions[2]);
        const mockup = root.querySelector('[data-mirror-mockup]');
        const availableWidth = Math.max(180, Math.min(320, root.querySelector('.mc-mirror__preview-stage').clientWidth - 16));
        const availableHeight = window.matchMedia('(max-width:899px)').matches ? 400 : 440;
        mockup.style.width = Math.min(availableWidth, availableHeight * width / height) + 'px';
        mockup.style.aspectRatio = width + ' / ' + height;
      };
      form.addEventListener('input', updatePreview);
      form.addEventListener('change', updatePreview);
      updatePreview();
      updateSize();
      window.addEventListener('resize', updateSize);
      root.querySelectorAll('[data-mirror-view]').forEach((button) => {
        button.addEventListener('click', () => {
          root.querySelectorAll('[data-mirror-panel]').forEach((panel) => { panel.hidden = panel.dataset.mirrorPanel !== button.dataset.mirrorView; });
          root.querySelectorAll('[data-mirror-view]').forEach((tab) => { tab.setAttribute('aria-pressed', String(tab === button)); });
          updateSize();
        });
      });
      form.querySelectorAll('input[name="id"]').forEach((radio) => {
        radio.addEventListener('change', () => {
          root.querySelectorAll('[data-mirror-price]').forEach((label) => { label.textContent = radio.dataset.price; });
          updateSize();
        });
      });
      const zoom = root.querySelector('[data-mirror-zoom]');
      zoom?.addEventListener('click', () => {
        const active = root.querySelector('.mc-mirror__photo-wrap').classList.toggle('is-zoomed');
        zoom.setAttribute('aria-pressed', String(active));
        zoom.textContent = active ? 'Vue complète ↙' : 'Voir les détails ↗';
      });
      form.querySelectorAll('[data-mirror-file]').forEach((input) => {
        let previewUrl;
        input.addEventListener('change', () => {
          input.setCustomValidity('');
          const status = input.parentElement.querySelector('[data-file-status]');
          const avatar = input.parentElement.querySelector('img');
          const avatarNumber = '1';
          const liveAvatar = root.querySelector('[data-preview-avatar="' + avatarNumber + '"]');
          const fallbackAvatar = root.querySelector('[data-avatar-fallback="' + avatarNumber + '"]');
          liveAvatar.hidden = true;
          fallbackAvatar.hidden = false;
          avatar.hidden = true;
          if (previewUrl) URL.revokeObjectURL(previewUrl);
          const file = input.files?.[0];
          if (!file) { status.textContent = 'Sélectionnez une photo.'; return; }
          if (file.size > 10 * 1024 * 1024) {
            input.setCustomValidity('Choisissez une photo de 10 Mo maximum.');
            status.textContent = 'Cette photo dépasse 10 Mo. Choisissez un fichier plus léger.';
            input.reportValidity();
            return;
          }
          if (!/\.(jpe?g|png|webp|heic|heif)$/i.test(file.name)) {
            input.setCustomValidity('Choisissez une photo JPG, PNG, WebP ou HEIC.');
            status.textContent = 'Format non accepté. Choisissez une photo JPG, PNG, WebP ou HEIC.';
            input.reportValidity();
            return;
          }
          status.textContent = file.name + ' · Photo sélectionnée';
          previewUrl = URL.createObjectURL(file);
          avatar.onload = () => { avatar.hidden = false; liveAvatar.src = previewUrl; liveAvatar.hidden = false; fallbackAvatar.hidden = true; };
          avatar.onerror = () => { avatar.hidden = true; status.textContent = file.name + ' · Photo sélectionnée (aperçu indisponible)'; };
          avatar.src = previewUrl;
        });
      });
      const submit = form.querySelector('[data-mirror-submit]');
      const error = form.querySelector('[data-mirror-error]');
      submit.disabled = root.hasAttribute('data-mirror-draft-preview');
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (root.hasAttribute('data-mirror-draft-preview')) return;
        if (!form.reportValidity()) return;
        submit.disabled = true;
        const originalText = submit.innerHTML;
        submit.textContent = 'Envoi de votre photo…';
        error.hidden = true;
        try {
          const payload = new FormData(form);
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST', body: payload, headers: { Accept: 'application/json' }
          });
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Votre miroir n’a pas pu être ajouté au panier. Veuillez réessayer.');
          window.location.assign(window.Shopify.routes.root + 'cart');
        } catch (exception) {
          error.textContent = exception.message || 'L’envoi a échoué. Vérifiez votre connexion puis réessayez.';
          error.hidden = false;
          submit.disabled = false;
          submit.innerHTML = originalText;
        }
      });
    });
  }
  initializeMoodMirrors();
  document.addEventListener('shopify:section:load', initializeMoodMirrors);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mood-wear-directory"] && !Shopify.designMode) return;
  try {
    
function setupMoodDirectory(){document.querySelectorAll('[data-mc-directory]').forEach(root=>{if(root.dataset.mcReady)return;root.dataset.mcReady='true';const search=root.querySelector('[data-mc-search]');const groups=Array.from(root.querySelectorAll('[data-mc-group]'));const empty=root.querySelector('[data-mc-empty]');const normalize=value=>value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();search.addEventListener('input',()=>{const query=normalize(search.value.trim());let matches=0;groups.forEach(group=>{const title=normalize(group.querySelector('summary').textContent);const groupMatch=title.includes(query);let links=0;group.querySelectorAll('[data-mc-link]').forEach(link=>{const found=!query||groupMatch||normalize(link.textContent).includes(query);link.hidden=!found;if(found)links++});group.hidden=links===0;group.open=!!query&&links>0;if(!group.hidden)matches++});empty.hidden=matches>0})})}
setupMoodDirectory();
document.addEventListener('shopify:section:load',setupMoodDirectory);

  } catch(e) { console.error(e); }
})();
})();
